type BadgeVariant =
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'default'
  | 'pending'
  | 'completed'
  | 'failed'
  | 'active'
  | 'inactive';

interface BadgeStyle {
  bg: string;
  text: string;
  border: string;
}

const badgeStyles: Record<BadgeVariant, BadgeStyle> = {
  success: {
    bg: 'bg-green-50',
    text: 'text-green-700',
    border: 'border-green-200',
  },
  danger: {
    bg: 'bg-red-50',
    text: 'text-red-700',
    border: 'border-red-200',
  },
  warning: {
    bg: 'bg-yellow-50',
    text: 'text-yellow-700',
    border: 'border-yellow-200',
  },
  info: {
    bg: 'bg-blue-50',
    text: 'text-blue-700',
    border: 'border-blue-200',
  },
  default: {
    bg: 'bg-gray-50',
    text: 'text-gray-700',
    border: 'border-gray-200',
  },
  pending: {
    bg: 'bg-yellow-50',
    text: 'text-yellow-700',
    border: 'border-yellow-200',
  },
  completed: {
    bg: 'bg-green-50',
    text: 'text-green-700',
    border: 'border-green-200',
  },
  failed: {
    bg: 'bg-red-50',
    text: 'text-red-700',
    border: 'border-red-200',
  },
  active: {
    bg: 'bg-green-50',
    text: 'text-green-700',
    border: 'border-green-200',
  },
  inactive: {
    bg: 'bg-gray-50',
    text: 'text-gray-700',
    border: 'border-gray-200',
  },
};

/**
 * Get badge styles based on status
 */
export const getBadgeStyles = (status?: string | boolean): BadgeStyle => {
  if (typeof status === 'boolean') {
    return badgeStyles[status ? 'active' : 'inactive'];
  }

  const statusLower = status?.toLowerCase();
  const variant = (statusLower as BadgeVariant) || 'default';

  return badgeStyles[variant] || badgeStyles.default;
};

/**
 * Get badge classes based on status
 */
export const getBadgeClass = (status?: string | boolean): string => {
  const styles = getBadgeStyles(status);
  return `inline-flex items-center gap-1 rounded-lg border px-2.5 py-1 text-xs font-medium ${styles.bg} ${styles.text} ${styles.border}`;
};

/**
 * Format badge label from status
 */
export const formatBadgeLabel = (status?: string | boolean): string => {
  if (typeof status === 'boolean') {
    return status ? 'Active' : 'Inactive';
  }

  if (!status) return 'Unknown';

  return status
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};
